import { format } from 'date-fns';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import * as selectors from '../selectors';
import { STATS_EMPTY_STATE_MODE } from '../typings';

import { EmptyState } from './stats__empty-state';

export const EmptyStateContainer = React.memo(() => {
    const mode = useSelector(selectors.getEmptyStateMode);
    const deadlineDate = useSelector(selectors.getEmptyStateDeadlineDate);

    const textId = useMemo(() => {
        switch (mode) {
            case STATS_EMPTY_STATE_MODE.FINISH_FORCED:
                return 'lessonView.stats.emptyState.lesson.finishedForced';
            case STATS_EMPTY_STATE_MODE.LESSON_IN_PROGRESS:
                return 'lessonView.stats.emptyState.lesson.inProgress';
            case STATS_EMPTY_STATE_MODE.NOT_EVALUATED:
                return 'lessonView.stats.emptyState.lesson.isNotEvaluated';
            case STATS_EMPTY_STATE_MODE.NOT_SOLVED:
                return 'lessonView.stats.emptyState.lesson.notSolved';
            case STATS_EMPTY_STATE_MODE.PROBLEM_IN_PROGRESS:
                return 'lessonView.stats.emptyState.problem.inProgress';
            default:
                return null;
        }
    }, [mode]);

    const values = useMemo(() => {
        let textValues;

        if (mode === STATS_EMPTY_STATE_MODE.NOT_EVALUATED) {
            textValues = { date: format(deadlineDate, 'dd.MM'), time: format(deadlineDate, 'HH:mm') };
        }

        return textValues;
    }, [deadlineDate, mode]);

    if (!textId) {
        return null;
    }

    return <EmptyState mix={`qa_stats-empty-state_${mode}`} textId={textId} values={values} />;
});

export default EmptyStateContainer;
